import request from '@utils/request';
import { setToken, clearToken } from '@utils/auth';
import { FormSubmissionError } from '@store/errors';

const PREFIX = '[GUEST]';

export const CREATE_GUEST_REQUEST = `${PREFIX} CREATE_GUEST_REQUEST`;
export const CREATE_GUEST_SUCCESS = `${PREFIX} CREATE_GUEST_SUCCESS`;
export const CREATE_GUEST_FAILURE = `${PREFIX} CREATE_GUEST_FAILURE`;

export const createGuestRequest = () => ({
  type: CREATE_GUEST_REQUEST,
});

export const createGuestSuccess = (payload) => ({
  type: CREATE_GUEST_SUCCESS,
  payload,
});

export const createGuestFailure = () => ({
  type: CREATE_GUEST_FAILURE,
});

export const createGuest = (propertyId, data) => (dispatch) => {
  dispatch(createGuestRequest());
  return request.post(`${propertyId}/guests`, data).then(
    ({ data }) => dispatch(createGuestSuccess(data)),
    (error) => {
      dispatch(createGuestFailure(error));

      if (error.response && error.response.data) {
        throw new FormSubmissionError(error.response.data);
      }
    }
  );
};

export const RESET_GUEST_PASSWORD_REQUEST = `${PREFIX} RESET_GUEST_PASSWORD_REQUEST`;
export const RESET_GUEST_PASSWORD_SUCCESS = `${PREFIX} RESET_GUEST_PASSWORD_SUCCESS`;
export const RESET_GUEST_PASSWORD_FAILURE = `${PREFIX} RESET_GUEST_PASSWORD_FAILURE`;

export const resetGuestPasswordRequest = () => ({
  type: RESET_GUEST_PASSWORD_REQUEST,
});

export const resetGuestPasswordSuccess = (payload) => ({
  type: RESET_GUEST_PASSWORD_SUCCESS,
  payload,
});

export const resetGuestPasswordFailure = () => ({
  type: RESET_GUEST_PASSWORD_FAILURE,
});

export const resetGuestPassword = (propertyId, data) => (dispatch) => {
  dispatch(resetGuestPasswordRequest());
  return request.post(`${propertyId}/guests/password/reset`, data).then(
    ({ data }) => dispatch(resetGuestPasswordSuccess(data)),
    (error) => {
      dispatch(resetGuestPasswordFailure(error));

      if (error.response && error.response.data) {
        throw new FormSubmissionError(error.response.data);
      }
    }
  );
};

export const SIGN_IN_REQUEST = `${PREFIX} SIGN_IN_REQUEST`;
export const SIGN_IN_SUCCESS = `${PREFIX} SIGN_IN_SUCCESS`;
export const SIGN_IN_FAILURE = `${PREFIX} SIGN_IN_FAILURE`;

export const signInRequest = () => ({
  type: SIGN_IN_REQUEST,
});

export const signInSuccess = (payload) => ({
  type: SIGN_IN_SUCCESS,
  payload,
});

export const signInFailure = () => ({
  type: SIGN_IN_FAILURE,
});

export const signIn = (propertyId, data) => (dispatch) => {
  dispatch(signInRequest());
  return request.post(`${propertyId}/guests/authenticate`, data, {}).then(
    ({ data }) => {
      setToken(data.token);
      return dispatch(signInSuccess(data.guest));
    },
    (error) => {
      dispatch(signInFailure(error));
      throw new FormSubmissionError({ _error: { code: 'login_failed' } });
    }
  );
};

export const LOGOUT = `${PREFIX} LOGOUT`;

export const logout = () => {
  clearToken();
  return {
    type: LOGOUT,
  };
};

export const GET_USER_REQUEST = `${PREFIX} GET_USER_REQUEST`;
export const GET_USER_SUCCESS = `${PREFIX} GET_USER_SUCCESS`;
export const GET_USER_FAILURE = `${PREFIX} GET_USER_FAILURE`;

export const getUserRequest = () => ({
  type: GET_USER_REQUEST,
});

export const getUserSuccess = (payload) => ({
  type: GET_USER_SUCCESS,
  payload,
});

export const getUserFailure = () => ({
  type: GET_USER_FAILURE,
});

export const getUser = (propertyId, headers) => (dispatch) => {
  dispatch(getUserRequest());
  return request.get(`${propertyId}/guests/details`, headers).then(
    ({ data }) => dispatch(getUserSuccess(data)),
    (error) => {
      dispatch(getUserFailure(error));
      if (error.response && error.response.data) {
        throw new FormSubmissionError(error.response.data);
      }
    }
  );
};

export const SET_PASSWORD_REQUEST = `${PREFIX} SET_PASSWORD_REQUEST`;
export const SET_PASSWORD_SUCCESS = `${PREFIX} SET_PASSWORD_SUCCESS`;
export const SET_PASSWORD_FAILURE = `${PREFIX} SET_PASSWORD_FAILURE`;

export const setPasswordRequest = () => ({
  type: SET_PASSWORD_REQUEST,
});

export const setPasswordSuccess = (payload) => ({
  type: SET_PASSWORD_SUCCESS,
  payload,
});

export const setPasswordFailure = () => ({
  type: SET_PASSWORD_FAILURE,
});

export const setPassword = (propertyId, token, data) => (dispatch) => {
  dispatch(setPasswordRequest());
  return request.post(`${propertyId}/guests/password/${token}`, data).then(
    ({ data }) => dispatch(setPasswordSuccess(data)),
    (error) => {
      dispatch(setPasswordFailure(error));
      if (error.response && error.response.data) {
        throw new FormSubmissionError(error.response.data);
      }
    }
  );
};

export const UPDATE_GUEST_REQUEST = `${PREFIX} UPDATE_GUEST_REQUEST`;
export const UPDATE_GUEST_SUCCESS = `${PREFIX} UPDATE_GUEST_SUCCESS`;
export const UPDATE_GUEST_FAILURE = `${PREFIX} UPDATE_GUEST_FAILURE`;

export const updateGuestRequest = () => ({
  type: UPDATE_GUEST_REQUEST,
});

export const updateGuestSuccess = (payload) => ({
  type: UPDATE_GUEST_SUCCESS,
  payload,
});

export const updateGuestFailure = () => ({
  type: UPDATE_GUEST_FAILURE,
});

export const updateGuest = (propertyId, guestId, data) => (dispatch) => {
  dispatch(updateGuestRequest());
  return request.patch(`${propertyId}/guests/${guestId}`, data).then(
    ({ data }) => dispatch(updateGuestSuccess(data)),
    (error) => {
      dispatch(updateGuestFailure(error));
      if (error.response && error.response.data) {
        throw new FormSubmissionError(error.response.data);
      }
    }
  );
};
